'use client';

import { useEffect, useState } from 'react';

import { SellerFlowAddressAutocomplete } from '@/components/forms/seller-flow-address-autocomplete';

const SHOW_STICKY_ADDRESS_AFTER_SCROLL_Y = 320;
const SHOW_HEADER_SCRIM_AFTER_SCROLL_Y = 500;

export function HomepageStickyAddress() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let frame = 0;

    const updateVisibility = () => {
      frame = 0;
      const nextIsVisible = window.scrollY >= SHOW_STICKY_ADDRESS_AFTER_SCROLL_Y;
      const nextHeaderScrimIsVisible = window.scrollY >= SHOW_HEADER_SCRIM_AFTER_SCROLL_Y;
      setIsVisible(nextIsVisible);
      document.body.dataset.homepageHeaderScrimVisible = nextHeaderScrimIsVisible
        ? 'true'
        : 'false';
    };

    const scheduleUpdate = () => {
      if (frame !== 0) return;
      frame = window.requestAnimationFrame(updateVisibility);
    };

    updateVisibility();
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    return () => {
      window.removeEventListener('scroll', scheduleUpdate);
      if (frame !== 0) window.cancelAnimationFrame(frame);
      delete document.body.dataset.homepageHeaderScrimVisible;
    };
  }, []);

  return (
    <div
      aria-hidden={!isVisible}
      className={`pointer-events-none fixed inset-x-0 top-0 z-[60] hidden transition duration-300 md:block ${
        isVisible ? 'translate-y-0 opacity-100' : '-translate-y-2 opacity-0'
      }`}
    >
      <div className="mx-auto flex h-[var(--homepage-header-height)] max-w-[1272px] items-center px-6 sm:px-12 lg:px-0">
        <div className="pointer-events-auto ml-[112px] w-[224px] [&_input]:rounded-xl [&_input]:border-line-strong [&_input]:bg-canvas/95 [&_input]:px-3 [&_input]:py-2 [&_input]:pr-9 [&_input]:text-[14px] [&_input]:leading-5 [&_input]:shadow-sm [&_input]:focus:ring-1 [&_span]:right-3">
          {isVisible ? (
            <SellerFlowAddressAutocomplete
              placeholder="Enter home address"
              channel="DEFAULT"
              loadingClassName="sr-only"
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
